import Typography from '@mui/material/Typography';
import { useUserHadTrial } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Unlock2 } from 'shared/assets/icons';
import { ColorScheme } from 'shared/assets/styles';
import { Button, Sizes } from 'shared/components/ui/button';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useTheme } from 'styled-components';

import * as Styled from './premium-message.style';

export const PremiumMessage: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const userHadTrial = useUserHadTrial();
  const openPremiumDialog = useOpenPremiumDialog();

  return (
    <Styled.Container>
      {theme.colorScheme === ColorScheme.Dark ? (
        <Styled.Image src="/images/premium/insights-no-premium-graphic-dm.jpg" />
      ) : (
        <Styled.Image src="/images/premium/insights-no-premium-graphic-lm.jpg" />
      )}
      <Styled.Overlay>
        <Styled.Dialog>
          <Styled.DialogContent>
            <Typography variant="h5" component="h2">
              {t('pages.insights.premium.title')}
            </Typography>
            <Typography variant="body2">
              {t('pages.insights.premium.description')}
            </Typography>
          </Styled.DialogContent>

          <Button
            size={Sizes.Large}
            startIcon={Unlock2}
            onClick={openPremiumDialog}
          >
            {t(
              userHadTrial
                ? 'pages.insights.premium.button.label'
                : 'pages.insights.premium.button.trial.label',
            )}
          </Button>
        </Styled.Dialog>
      </Styled.Overlay>
    </Styled.Container>
  );
};
